<div class="section-heading dds-mb-3">
    <div class="section-title">Create a new Service
    </div>
    <div class="dds-label greyed-out">
        Set up a new service to work with one of your API specs.
    </div>
</div>

<div class="dds-label greyed-out dds-mb-1">
    Service type
</div>

<div class="dds-label greyed-out dds-mb-1">
    Choose what kind of service you want to create
</div>

<div class="input-container dds-mb-3">
    <dds-dropdown [theme]="serviceTypeDropdownOptions.theme" [kind]="serviceTypeDropdownOptions.kind"
        [size]="serviceTypeDropdownOptions.size" [label]="serviceTypeDropdownOptions.label"
        [width]="serviceTypeDropdownOptions.width" [isInverse]="serviceTypeDropdownOptions.isInverse"
        [isColorBg]="serviceTypeDropdownOptions.isColorBg" [disabled]="serviceTypeDropdownOptions.disabled"
        [customClass]="serviceTypeDropdownOptions.customClass" [isResponsive]="serviceTypeDropdownOptions.isResponsive"
        [stickerWidth]="serviceTypeDropdownOptions.stickerWidth"
        [stickerIsOutsideClick]="serviceTypeDropdownOptions.stickerIsOutsideClick"
        [stickerShift]="serviceTypeDropdownOptions.stickerShift"
        [stickerMaxHeight]="serviceTypeDropdownOptions.stickerMaxHeight"
        [stickerIsDisabled]="serviceTypeDropdownOptions.stickerIsDisabled"
        [stickerPosition]="serviceTypeDropdownOptions.stickerPosition"
        [stickerIndent]="serviceTypeDropdownOptions.stickerIndent"
        [stickerCustomClass]="serviceTypeDropdownOptions.stickerCustomClass"
        [stickerIsDynamic]="serviceTypeDropdownOptions.stickerIsDynamic" (itemSelected)="serviceTypeSelected($event)">

        @for (item of serviceTypeDropdownItems; track item) {
        <dds-dropdown-item [value]="item.value" [counter]="item.counter"
            [disabled]="item.disabled">{{item.heading}}</dds-dropdown-item>
        }

    </dds-dropdown>
</div>

<div class="dds-label greyed-out dds-mb-1">
    API specification
</div>

<div class="dds-label greyed-out dds-mb-1">
    Choose which API specification this service will use
</div>

<div class="input-container dds-mb-3">
    <dds-dropdown [theme]="specificationDropdownOptions.theme" [kind]="specificationDropdownOptions.kind"
        [size]="specificationDropdownOptions.size" [label]="specificationDropdownOptions.label"
        [width]="specificationDropdownOptions.width" [isInverse]="specificationDropdownOptions.isInverse"
        [isColorBg]="specificationDropdownOptions.isColorBg" [disabled]="specificationDropdownOptions.disabled"
        [customClass]="specificationDropdownOptions.customClass"
        [isResponsive]="specificationDropdownOptions.isResponsive"
        [stickerWidth]="specificationDropdownOptions.stickerWidth"
        [stickerIsOutsideClick]="specificationDropdownOptions.stickerIsOutsideClick"
        [stickerShift]="specificationDropdownOptions.stickerShift"
        [stickerMaxHeight]="specificationDropdownOptions.stickerMaxHeight"
        [stickerIsDisabled]="specificationDropdownOptions.stickerIsDisabled"
        [stickerPosition]="specificationDropdownOptions.stickerPosition"
        [stickerIndent]="specificationDropdownOptions.stickerIndent"
        [stickerCustomClass]="specificationDropdownOptions.stickerCustomClass"
        [stickerIsDynamic]="specificationDropdownOptions.stickerIsDynamic"
        (itemSelected)="specificationSelected($event)">

        @for (item of specificationDropdownItems; track item) {
        <dds-dropdown-item [value]="item.value" [counter]="item.counter"
            [disabled]="item.disabled">{{item.heading}}</dds-dropdown-item>
        }

    </dds-dropdown>
</div>

<div class="dds-label greyed-out dds-mb-1">
    Service name
</div>

<div class="dds-label greyed-out dds-mb-1">
    Choose a descriptive name that explains what this service does
</div>

<div class="input-container dds-mb-3">
    <dds-input [formControl]="inputFormCtrl" [label]="inputOptions.label" [labelPosition]="inputOptions.labelPosition"
        [placeholder]="inputOptions.placeholder" [isRequired]="inputOptions.isRequired"
        [isInverse]="inputOptions.isInverse" [isError]="inputOptions.isError" [readonly]="inputOptions.readonly"
        [size]="inputOptions.size" [description]="inputOptions.description" [errorMessage]="inputOptions.errorMessage"
        [errorState]="inputOptions.errorState" [descriptionType]="inputOptions.descriptionType"
        [maxLength]="inputOptions.maxLength" [maxLengthPosition]="inputOptions.maxLengthPosition"
        [textAlign]="inputOptions.textAlign" [type]="inputOptions.type" (valueChanged)="changeValue()"
        (onBlur)="onBlur()"></dds-input>
</div>

<div class="dds-label greyed-out dds-mb-1">
    Description
</div>

<div class="dds-label greyed-out dds-mb-1">
    Help your team understand what this service is for
</div>

<div class="input-container dds-mb-3">
    <dds-textarea [formControl]="textareaFormCtrl" [label]="textareaOptions.label"
        [labelPosition]="textareaOptions.labelPosition" [placeholder]="textareaOptions.placeholder"
        [description]="textareaOptions.description" [minHeight]="textareaOptions.minHeight"
        [isRequired]="textareaOptions.isRequired" [isInverse]="textareaOptions.isInverse"
        [isError]="textareaOptions.isError" [errorMessage]="textareaOptions.errorMessage"
        [errorState]="textareaOptions.errorState" [maxLength]="textareaOptions.maxLength"
        [maxLengthPosition]="textareaOptions.maxLengthPosition" [size]="textareaOptions.size"
        [readonly]="textareaOptions.readonly" (valueChanged)="descriptionValueChanged()"></dds-textarea>
</div>


<div class="buttons-wrapper">
    <dds-button [theme]="cancelButtonOptions.theme" [kind]="cancelButtonOptions.kind" [size]="cancelButtonOptions.size"
        [width]="cancelButtonOptions.width" [icon]="cancelButtonOptions.icon"
        [isIconLeft]="cancelButtonOptions.isIconLeft" [role]="cancelButtonOptions.role"
        [isInverse]="cancelButtonOptions.isInverse" [isColorBg]="cancelButtonOptions.isColorBg"
        [isLoading]="cancelButtonOptions.isLoading" [ariaLabel]="cancelButtonOptions.ariaLabel"
        [customClass]="cancelButtonOptions.customClass" (clicked)="cancelClick($event)">Cancel</dds-button>

    <dds-button [theme]="addServiceButtonOptions.theme" [kind]="addServiceButtonOptions.kind"
        [size]="addServiceButtonOptions.size" [width]="addServiceButtonOptions.width"
        [icon]="addServiceButtonOptions.icon" [isIconLeft]="addServiceButtonOptions.isIconLeft"
        [role]="addServiceButtonOptions.role" [isInverse]="addServiceButtonOptions.isInverse"
        [isColorBg]="addServiceButtonOptions.isColorBg" [isLoading]="addServiceButtonOptions.isLoading"
        [ariaLabel]="addServiceButtonOptions.ariaLabel" [customClass]="addServiceButtonOptions.customClass"
        (clicked)="addServiceClick()">Create service</dds-button>
</div>